<template>
    <div id="signup-page">
        <Signup />
    </div>
</template>

<script>
  import Signup from './views/Signup'

  export default {
    name: 'signup-wrapper',
    components: {
      Signup
    }
  }
</script>
<style lang="scss" scoped>
    #signup-page {
        background: var(--main-feature-background-color);
        padding: 4em 0;
        font-family: var(--main-font);

        .illustration {
            width: 30%;
            filter: drop-shadow(4px 5px 0px rgba(0, 0, 0, 0.1));
        }

        .slide-fade-enter-active {
            transition: all .3s ease;
        }
        .slide-fade-leave-active {
            transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-enter, .slide-fade-leave-to
        {
            transform: translateX(10px);
            opacity: 0;
        }

     ::v-deep .vc-signup-module__submit {
        color: var(--main-button-primary-text-color);
        background: var(--main-button-primary-background-color);
        margin-right: 1em;

        &:hover,
        &:active,
        &:focus {
          background: var(--main-button-primary-highlight-background-color);
        }
      }

       ::v-deep .vc-signup-module__submit,
       ::v-deep .btn {
            padding: 1em 2em;
            font-size: 0.875em;
            text-align: center;
            cursor: pointer;
            text-decoration: none;
            border-radius: .25em;
            border: 1px solid transparent;
            transition: var(--main-transition);

            &[disabled] {
              cursor: not-allowed;
            }

            &.btn-primary {
              background: var(--main-button-primary-background-color);
              color:var(--main-button-primary-text-color);

              &:hover {
                  background: var(--main-button-primary-highlight-background-color);
              }
            }
        }

       ::v-deep .form {

            .form-row {
                display: flex;
                font-family: var(--main-font);
            }

            .input-group {
                flex: 1;
                margin:0 -1rem;
                .input {
                    flex: 2;
                    position: relative;
                    margin: 0;
                    padding:1rem;
                    box-sizing: border-box;

                    &.select {
                        flex: 1;
                    }

                    &:after {
                        position: absolute;
                        content: "";
                        border-bottom: 2px solid var(--main-darker-grey);
                        bottom: 0;
                        width: 0;
                        height: 2px;
                        margin: auto;
                        right: 0;
                        left: 0;
                        transition: var(--main-transition);
                    }

                    &:hover {
                        label {
                            top: -1.5em;
                        }

                        &:after {
                            border-color: var(--main-primary);
                            width: 100%;
                        }
                    }

                    label {
                        position: absolute;
                         top: 1.5em;
                        left: 1.5em;
                        transition: var(--main-transition);
                        color: var(--main-primary);
                        font-weight: bold;
                        font-size: 1em;
                        z-index: 1;
                    }

                    .form-control {
                        padding: 1.7em 0 .4em .5em;
                        font-size: 1.1em;
                        border-width: 0;
                        transition: var(--main-transition);
                        outline: 0;
                        width: 100%;
                        color: var(--main-text);
                        background: #FFF;
                        border-bottom: 1px solid transparent;
                        margin-bottom: 0;
                        min-height: 3.6em;
                        box-shadow: 0px 0px 0 1px var(--main-border-color);

                        &.disabled {
                            background: rgba(0, 0, 0, 0.05) !important;
                        }
                        &:focus {
                            background: var(--main-light-yellow) !important;
                        }
                    }

                    select {
                        &.form-control {
                            padding-bottom: .7em;
                        }
                    }
                }
            }
        }
    }
</style>
